import {
  CART_OFFER_COMPARISON_ADD_SELECTION,
  CART_OFFER_COMPARISON_REMOVE_SELECTION,
  CART_OFFER_COMPARISON_REPLACE_SELECTION,
  CART_OFFER_COMPARISON_CLEAR_ALL,
  API_CALL,
} from './actionConstants'
import {
  FETCH_CART_OFFER_COMPARISON_ITEMS,
  CREATE_CART_OFFER_COMPARISON_ITEM,
} from './apiActionConstants'
import * as cartOfferComparisonAPI from 'api/cartOfferComparison'
import { AppAction } from './types/ActionTypes'

export function addCartOfferComparisonSelection(selection: App.OfferComparisonSelection): AppAction {
  return {
    type: CART_OFFER_COMPARISON_ADD_SELECTION,
    selection,
  }
}

export function removeCartOfferComparisonSelection(selectionId: string): AppAction {
  return {
    type: CART_OFFER_COMPARISON_REMOVE_SELECTION,
    selectionId,
  }
}

export function replaceCartOfferComparisonSelection(selection: App.OfferComparisonSelection): AppAction {
  return {
    type: CART_OFFER_COMPARISON_REPLACE_SELECTION,
    selection,
  }
}

export function clearAllCartOfferComparisonSelections(): AppAction {
  return {
    type: CART_OFFER_COMPARISON_CLEAR_ALL,
  }
}

export function fetchCartOfferComparisonItems(): AppAction {
  return {
    type: API_CALL,
    api: FETCH_CART_OFFER_COMPARISON_ITEMS,
    request: () => cartOfferComparisonAPI.getActiveComparisonItems(),
  }
}

export function createCartOfferComparison(): AppAction {
  return (dispatch, getState) => {
    const state: App.State = getState()

    const spoofedSelections = state.cartOfferComparison.spoofedSelections

    if (!spoofedSelections.length) {
      return
    }

    dispatch({
      type: API_CALL,
      api: CREATE_CART_OFFER_COMPARISON_ITEM,
      request: () => cartOfferComparisonAPI.createCartOfferComparison(spoofedSelections),
    })
  }
}
